import React from "react";
import styles from './Progress.module.less';
export function Progress({ percent }) {
    return (React.createElement("div", { className: styles.root },
        React.createElement("div", { style: { transform: `scaleX(${percent / 100})` } })));
}
